import React, { Component, PropTypes } from 'react';
import PageLayoutStore from 'stores/PageLayout';
import { PageLayoutActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import PageModuleMenu from 'components/Page/PageModuleMenu';

class PageLayoutContainer extends mixin(RefluxMixin, Component) {
  static propTypes = {
    children: PropTypes.node,
    params: PropTypes.object,
    history: PropTypes.object
  };

  componentDidMount() {}

  listenToStores() {
    this.listenToStoreWithMapper(PageLayoutStore, state => {
      return {
        open: state.moduleMenuEnabled,
        ...this.mapActions({
          closeModuleMenu: PageLayoutActions.closeModuleMenu,
          addPageModule: PageLayoutActions.addPageModule
        })
      };
    });
  }

  render() {
    const { loading, open, ...other } = this.state;
    return <PageModuleMenu open={open} {...other} {...this.props} />;
  }
}

export default PageLayoutContainer;



// WEBPACK FOOTER //
// ./src/js/containers/PageModuleMenuContainer.js